module.exports = "/images/Dotag_logo-21.svg?5eec867336058c771f69d80d771aeb20";